import { render, staticRenderFns } from "./MassUpdateHistory.vue?vue&type=template&id=56165b67&scoped=true&"
import script from "./MassUpdateHistory.vue?vue&type=script&lang=js&"
export * from "./MassUpdateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56165b67",
  null
  
)

export default component.exports